import React from 'react';

const AddProduct = () => {
    return (
        <div>
            <h2>add product</h2>
        </div>
    );
};

export default AddProduct;